import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

/**
 * Einstellungen › KI & Limits: Monatskontingent in Credits je interner Nutzer
 * und Bereich (al-user-management migration 060).
 *
 * Tenant comes from the token on the server; only client admins (and
 * super_admin) get past the endpoint. Enforcement lives where the action
 * starts — `creator` in al-tutor's Canvas preflight, `parsing` in
 * al-filemanager's import endpoints.
 */

export type LimitArea = 'creator' | 'parsing';

export interface AreaLimitState {
  /** Effective limit: own, else the client default; null = unlimited. */
  limit_credits: number | null;
  /** True when the user has an own limit (not the default). */
  own_limit: boolean;
  used_milli: number;
}

export interface UserLimitRow {
  user_id: string;
  name: string | null;
  email: string;
  role: string;
  areas: Record<LimitArea, AreaLimitState>;
}

export interface CreditLimitsOverview {
  areas: LimitArea[];
  month_start: string;
  defaults: Record<LimitArea, number | null>;
  users: UserLimitRow[];
}

@Injectable({ providedIn: 'root' })
export class CreditLimitsService {
  private readonly base = `${environment.userBackend}/credit-limits`;

  constructor(private http: HttpClient) {}

  get(): Observable<CreditLimitsOverview> {
    return this.http.get<{ data: CreditLimitsOverview }>(this.base).pipe(map((r) => r.data));
  }

  /** `userId` null = client default; `monthlyCredits` null = no limit /
   *  back to the default. Returns the refreshed overview. */
  set(userId: string | null, area: LimitArea, monthlyCredits: number | null): Observable<CreditLimitsOverview> {
    return this.http
      .put<{ data: CreditLimitsOverview }>(this.base, {
        user_id: userId,
        area,
        monthly_credits: monthlyCredits,
      })
      .pipe(map((r) => r.data));
  }
}
